import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const scrollDocumentToTop = () => {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    scrollDocumentToTop();
    const frame = window.requestAnimationFrame(scrollDocumentToTop);
    return () => window.cancelAnimationFrame(frame);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
